/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import { has } from 'lodash';

let config = window.apiConnectExplorer || null;

if (has(window, 'drupalSettings.api.explorer')) {
  config = window.drupalSettings.api.explorer;
} else if (has(window, 'Drupal.settings.api.explorer')) {
  // support for Drupal7 style Drupal.settings
  config = window.Drupal.settings.api.explorer;
} // Use props instead if provided
// eslint-disable-next-line no-unused-vars
/* global __webpack_public_path__:writable */
__webpack_public_path__ = config?.options?.explorerDir || '/';
